var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 9.5C16.625 9.65747 16.5624 9.8085 16.4511 9.91985C16.3397 10.0312 16.1887 10.0938 16.0312 10.0938H10.0938V16.0312C10.0938 16.1887 10.0312 16.3397 9.91985 16.4511C9.8085 16.5624 9.65747 16.625 9.5 16.625C9.34253 16.625 9.1915 16.5624 9.08016 16.4511C8.96881 16.3397 8.90625 16.1887 8.90625 16.0312V10.0938H2.96875C2.81128 10.0938 2.66026 10.0312 2.54891 9.91985C2.43756 9.8085 2.375 9.65747 2.375 9.5C2.375 9.34253 2.43756 9.1915 2.54891 9.08016C2.66026 8.96881 2.81128 8.90625 2.96875 8.90625H8.90625V2.96875C8.90625 2.81128 8.96881 2.66026 9.08016 2.54891C9.1915 2.43756 9.34253 2.375 9.5 2.375C9.65747 2.375 9.8085 2.43756 9.91985 2.54891C10.0312 2.66026 10.0938 2.81128 10.0938 2.96875V8.90625H16.0312C16.1887 8.90625 16.3397 8.96881 16.4511 9.08016C16.5624 9.1915 16.625 9.34253 16.625 9.5Z",
    fill: "#1B4EA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ac3edff4d46c14364d5a2e2c6307bb99.svg";
export { ForwardRef as ReactComponent };